<template>
  <section>
      </br>
      </br>
      <!-- <div style="position: absolute;top: 50%;left: 50%;"> -->
          <div>
<el-row>

  

    <el-col :span="18"  >
    <el-card :body-style="{ padding: '0px' }">
      <!-- <img v-if="o==2" :src="WeChat" class="image"> -->
      <div style="padding: 14px;">
        <!-- <span v-if="o==1">支付宝</span> -->
        <!-- </br> -->
          <table style="width:100%">
            <tr>
              <td style="width:50%">
          <span  style="color:red">收款人陈蒙蒙 目前仅支持支付宝付款</span>
          </br>
            </br>
         <span  style="color:blue">本门店 剩余短信数量:{{Count}} 已使用短信数量:{{UseCount}}</span>
           </br>
             </br>
        <span >请在支付备注中注明门店信息</span>
            </br> 
              </br>      
         <span >为了便于短信功能管理，每次充值金额以1000元为单位，如1000元，2000元，以此类推；不要出现充值1500元或者1800元这样的零散金额，谢谢合作</span>          
              </td>
              <td style="width:50%;">
                 <!-- :background="MsgDescription" -->
                <img style="width:100%;height:100%"  :src="MsgDescription"  >

              </td>
            </tr>
          </table>
        <!-- <span v-if="i==1" style="color:red">收款人陈蒙蒙 目前仅支持支付宝付款</span>
        </br>
        </br>
        <span v-if="i==1" style="color:blue">本门店 剩余短信数量:{{Count}} 已使用短信数量:{{UseCount}}</span>
        <br>
        </br>
        <div>
        <span v-if="i==1">请在支付备注中注明门店信息</span>
        </br>
        </br>
        <span v-if="i==1">为了便于短信功能管理，每次充值金额以1000元为单位，如1000元，2000元，以此类推；不要出现充值1500元或者1800元这样的零散金额，谢谢合作</span> -->

        <!-- </div> -->
        <div class="bottom clearfix">
          <!-- <time class="time">{{ currentDate }}</time> -->
          <el-button type="text" class="button" @click="rechargeLog()">历史充值记录</el-button>
        </div>
      </div>
    </el-card>
  </el-col>
 <el-col :span="24"><br></el-col>
  <el-col :span="4">
    <el-card :body-style="{ padding: '0px' }">
      <!-- <img v-if="o==2" :src="WeChat" class="image"> -->
      <img  :src="Alipay" class="image">
      <div style="padding: 14px;">
        <!-- <span v-if="o==1" style="color:red">收款人陈蒙蒙 目前仅支持支付宝付款</span>
        </br>
        <span v-if="o==1" style="color:blue">本门店 剩余短信数量:{{Count}} 已使用短信数量:{{UseCount}}</span>
        <br>
        <span v-if="o==1">请在支付备注中注明门店信息</span>
          </br>
        <span v-if="o==1">为了便于短信功能管理，每次充值金额以1000元为单位，如1000元，2000元，以此类推；不要出现充值1500元或者1800元这样的零散金额，谢谢合作</span> -->
        <div class="bottom clearfix">
          <!-- <time class="time">{{ currentDate }}</time> -->
          <el-button type="text" class="button" @click="rechargeLog()">历史充值记录</el-button>
        </div>
      </div>
    </el-card>
  </el-col>
</el-row>

      </div>
  	<!-- 充值记录 -->
        <el-dialog  v-model="dialogTableVisible" >
           <el-table :data="ShopRechargeData" highlight-current-row v-loading="logLoading">	
			<el-table-column prop="Count" label="充值数量" width="120" sortable>
			</el-table-column>
			<el-table-column prop="UnitPrice" label="充值单价" width="120" sortable>
			</el-table-column>				
			<el-table-column prop="Money" label="充值金额" width="120" sortable>
			</el-table-column>			
			<el-table-column prop="CreationTime" label="充值时间" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>

		    <el-table-column prop="State" label="记录状态"  width="120" sortable fixed="right">  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="danger" size="medium" v-if="scope.row.State==0">已撤销</el-tag>
                  <el-tag type="success" size="medium" v-else>正常</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<!-- <el-table-column label="操作" width="100" fixed="right">
				<template  slot-scope="scope">
					<el-button type="danger" size="small" :disabled="scope.row.State==0" @click="cancel(scope.$index, scope.row)">撤销充值</el-button>				
				</template>
			</el-table-column> -->
           </el-table>
		   	<el-col :span="24" class="toolbar">
			<el-tag>共有{{logCount}}条充值记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="CurrentChange" :page-size="10" :total="logCount" style="float:right;">
			</el-pagination>
	     	</el-col>
        </el-dialog>
  </section>
</template>
<style scoped>
  .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
</style>

<script>
// import WeChat from "../../assets/images/WeChat.png"
import Alipay from "../../assets/images/Alipay.png";
import MsgDescription from "../../assets/images/MsgDescription.png";

	import {mapGetters} from 'vuex';

   import {getShopInfor,editshopt,rechargeLogPaging} from  '../../api/api';

export default {
  data() {
    return {
        // WeChat:WeChat,
        	dialogTableVisible:false,
				  ShopRechargeData:[],
				  logCount:0,
				  ShopId:0,
				  logLoading:false,
				  logPage:0,

        Count:0,
        UseCount:0,
        Alipay:Alipay,
        MsgDescription:MsgDescription,
      currentDate: new Date()
    };

  },
  methods:{
    	CurrentChange(val)
			{
        this.logPage = val;
				this.rechargeLogData();
			},
    	rechargeLog:function(){
				this.dialogTableVisible=true;
				// this.TitleName=row.Name;
				// this.ShopId=row.Id;
				this.ShopRechargeData=[];
				this.rechargeLogData();
			},
			rechargeLogData(){
				let Params = {
					PageIndex: this.logPage-1,					
					PageSize:10,
					ShopId:this.ShopId
				};			
				this.logLoading	=true;  
				  rechargeLogPaging(Params).then((res) => {
					//前端mock测试
					this.logCount = res.data.TotleCount;
					this.ShopRechargeData = res.data.Data;
					this.logLoading=false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
     ...mapGetters(['getuserstate']),
	   getStoryInfo:function(){
          let TenancyId=JSON.parse(this.getuserstate()).TenancyId;
          this.ShopId=TenancyId;
					// console.log(localhoststoryid.storyid);
					let para ={
						TenancyId:TenancyId
					}
           getShopInfor(para).then((res)=>{
						//  console.log(res);
						 let list=res.data;
						 if(list.lenght<1)
						 {

						 }
						 else
						 {
              //  console.log(res.data[0]);
						 this.Count=res.data[0].Count;
             this.UseCount=res.data[0].UsageAmount;
						 }

					 })
		 },
  },
  	 mounted() {
			this.getStoryInfo();
		}
}
</script>



// WEBPACK FOOTER //
// ShopPay.vue?3d98f8b2